import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const STEPS = ["Job description", "Review requirements", "Stages and publish"];

export function Stepper({ step, reachable, onGo }) {
  return (
    <ol className="flex flex-wrap items-center gap-2" data-testid="wizard-stepper">
      {STEPS.map((label, i) => {
        const n = i + 1;
        const done = step > n;
        const current = step === n;
        const can = reachable(n);
        return (
          <li key={label} className="flex items-center gap-2">
            <button
              disabled={!can}
              onClick={() => onGo(n)}
              data-testid={`wizard-step-${n}-btn`}
              className={cn(
                "flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors duration-150",
                current ? "border-brand bg-brand-tint text-brand font-medium" : done ? "border-line bg-white text-ink" : "border-line bg-white text-ink-muted",
                can && !current && "hover:bg-subtle",
                !can && "cursor-not-allowed"
              )}
            >
              <span className={cn("flex h-5 w-5 items-center justify-center rounded-full text-xs", done ? "bg-success text-white" : current ? "bg-brand text-white" : "border border-line")}>
                {done ? <Check size={12} /> : n}
              </span>
              {label}
            </button>
            {n < STEPS.length && <span className="h-px w-6 bg-line" />}
          </li>
        );
      })}
    </ol>
  );
}

export const SaveIndicator = ({ state }) => {
  const text = { idle: "Drafts save automatically", saving: "Saving…", saved: "All changes saved", error: "Couldn't save" }[state];
  return <span data-testid="autosave-status" className={cn("text-xs", state === "error" ? "text-risk" : "text-ink-muted")}>{text}</span>;
};
